import React, { useState } from 'react';

const FAQ = () => {
  // Estado para controlar qual pergunta está aberta (null = nenhuma)
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      pergunta: "A Gummy é indicada para todos os cachorros?",
      resposta: "Sim! A PAWS Premium Balance Gummy 24 em 1 foi desenvolvida para cães adultos de todas as raças e portes, oferecendo uma nutrição completa e segura. Para filhotes com menos de 3 meses, cães idosos com condições específicas ou pets em tratamento, recomenda-se conversar com o veterinário antes de iniciar o uso."
    },
    {
      pergunta: "Meu cachorro já come ração de ótima qualidade — não seria demais para ele?",
      resposta: "Não. A Gummy foi criada para complementar a alimentação, mesmo em cães que consomem rações premium ou naturais. Fatores como absorção individual, idade, rotina, estresse e clima podem influenciar o aproveitamento dos nutrientes. A Gummy atua como um reforço nutricional diário, ajudando a manter o equilíbrio geral do organismo sem sobrecarregar o corpo do pet."
    },
    {
      pergunta: "A Gummy ajuda em casos de queda de pelos ou pelagem opaca?",
      resposta: "A fórmula contém colágeno, biotina, zinco e vitaminas que contribuem para a nutrição da pele e pelagem. Esses nutrientes ajudam a manter os fios mais resistentes e com aparência saudável, quando associados a uma alimentação equilibrada."
    },
    {
      pergunta: "E se o meu cão tem coceiras ou pele sensível?",
      resposta: "A Gummy combina vitaminas A, D3, E, colina e triptofano, que colaboram com o equilíbrio cutâneo e o bom funcionamento do organismo. Ela não é um medicamento, mas pode complementar a nutrição e oferecer suporte para a manutenção da saúde da pele."
    },
    {
      pergunta: "Meu cachorro anda sem energia. A Gummy ajuda nisso?",
      resposta: "Sim. A Gummy contém colina e vitaminas do complexo B, que participam do metabolismo energético e do equilíbrio neurológico. Esses nutrientes ajudam a manter uma rotina mais ativa e saudável, sem prometer efeitos imediatos."
    },
    {
      pergunta: "Ele vive ficando doente quando o clima muda. Posso dar a Gummy?",
      resposta: "A fórmula contém vitaminas A, C, D3 e E, que oferecem suporte às defesas naturais do organismo. Esses nutrientes ajudam o corpo do pet a se manter equilibrado e bem nutrido, especialmente em períodos de variação climática."
    },
    {
      pergunta: "A Gummy pode ajudar na digestão?",
      resposta: "Sim. A presença de matéria mineral e fibrosa auxilia no equilíbrio intestinal e na rotina digestiva. Ela atua como um apoio nutricional diário, integrando-se à alimentação para favorecer o bom funcionamento do sistema digestivo."
    },
    {
      pergunta: "E para cães idosos ou com dificuldade de locomoção?",
      resposta: "A Gummy contém colágeno, cálcio, condroitina e glicosamina, ingredientes tradicionalmente usados em fórmulas voltadas à saúde articular. Esses componentes ajudam a preservar a mobilidade e o conforto, podendo ser aliados na rotina de cães maduros."
    },
    {
      pergunta: "Meu cachorro não aceita cápsulas. Ele vai aceitar essa Gummy?",
      resposta: "Muito provavelmente sim! A PAWS desenvolveu a Gummy com textura macia e sabor atrativo, tornando o momento de suplementação prazeroso e fácil, como um petisco funcional."
    },
    {
      pergunta: "Com que frequência devo dar a Gummy?",
      resposta: "A Gummy foi pensada para uso diário. A dosagem ideal varia conforme o peso e deve seguir as instruções da embalagem. Em caso de dúvida, o veterinário pode ajustar a dose conforme a necessidade individual do pet."
    },
    {
      pergunta: "Posso oferecer junto com a ração ou alimentação natural?",
      resposta: "Sim! A Gummy não substitui a alimentação, mas complementa o cardápio diário. Ela pode ser oferecida sozinha, como petisco, ou junto da refeição principal."
    },
    {
      pergunta: "Em quanto tempo verei os efeitos?",
      resposta: "Cada organismo reage de forma diferente. O uso contínuo da Gummy contribui para manter o equilíbrio nutricional e favorecer aspectos visíveis de bem-estar, como disposição e aparência da pelagem. Em geral, tutores percebem melhorias graduais após algumas semanas de uso consistente."
    },
    {
      pergunta: "Serve mesmo que o meu pet esteja saudável?",
      resposta: "Sim! A Gummy 24 em 1 é ideal tanto para manutenção quanto para prevenção. Ela ajuda a garantir que o pet receba todos os nutrientes essenciais mesmo em uma rotina saudável, contribuindo para longevidade e vitalidade a longo prazo."
    },
    {
      pergunta: "Posso dar Gummy para uma fêmea gestante?",
      resposta: "Durante a gestação, a suplementação pode ser uma aliada, mas cada caso é único. Por isso, é essencial consultar o veterinário, que poderá avaliar se a Gummy se encaixa na dieta da cadela gestante de forma segura."
    },
    {
      pergunta: "Posso associar a Gummy com outros suplementos?",
      resposta: "Pode, desde que haja orientação veterinária. Como a Gummy já reúne 24 ingredientes importantes, o ideal é verificar com o profissional se há necessidade de outro produto, evitando sobreposição de nutrientes."
    },
    {
      pergunta: "Por que a Gummy é considerada 24 em 1?",
      resposta: "Porque sua fórmula contém 24 ingredientes essenciais — entre aminoácidos, minerais e vitaminas que atuam em diferentes aspectos da saúde canina: articulações, imunidade, metabolismo, pele, pelagem e bem-estar geral. Consulte a tabela acima disponível nessa página para maiores informações."
    }
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        
        <h2 style={styles.title}>PERGUNTAS FREQUENTES</h2>
        
        <div style={styles.faqList}>
          {faqData.map((item, index) => (
            <div 
              key={index} 
              style={{
                ...styles.item,
                backgroundColor: activeIndex === index ? '#fdfdfd' : '#fff',
                borderColor: activeIndex === index ? '#5D2E8C' : '#eee'
              }}
            >
              <button 
                onClick={() => toggleFAQ(index)} 
                style={styles.questionButton}
              >
                <span style={styles.questionText}>{item.pergunta}</span>
                <span style={{
                    ...styles.icon,
                    transform: activeIndex === index ? 'rotate(45deg)' : 'rotate(0deg)'
                }}>
                  +
                </span>
              </button>
              
              {activeIndex === index && (
                <div style={styles.answerContainer}>
                  <p style={styles.answerText}>
                    {item.resposta}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '60px 20px',
    backgroundColor: '#fff',
    textAlign: 'center'
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto'
  },
  title: {
    color: '#5D2E8C',
    fontSize: '2.5rem',
    fontFamily: '"Titan One", sans-serif',
    marginBottom: '40px',
    textTransform: 'uppercase'
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  item: {
    border: '2px solid #eee',
    borderRadius: '15px',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    textAlign: 'left',
    boxShadow: '0 4px 10px rgba(0,0,0,0.03)'
  },
  questionButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    outline: 'none'
  },
  questionText: {
    fontSize: '1.1rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: '"Montserrat", sans-serif',
    textAlign: 'left',
    paddingRight: '10px'
  },
  icon: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#32CD32', // Verde
    transition: 'transform 0.3s ease',
    lineHeight: '1'
  },
  answerContainer: {
    padding: '0 20px 25px 20px',
    borderTop: '1px solid #f0f0f0'
  },
  answerText: {
    fontSize: '1rem',
    color: '#555',
    lineHeight: '1.6',
    fontFamily: '"Commissioner", sans-serif',
    margin: '15px 0 0 0'
  }
};

export default FAQ;